import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class BackorderPolicy extends BasePolicy {
  static canList() {
    const roles = [
      Roles.SELLER,
      Roles.CUSTOMER_RETAIL,
      Roles.CUSTOMER_WHOLESALER,
      Roles.MANAGER,
      Roles.SUB_MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.EXPRESS_SALES,
      Roles.CREDIT_ASSISTANT,
      Roles.SUB_DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUPER_USER,
      Roles.MARKETING,
      Roles.POST_SALE,
    ];

    const channels = [Channels.WHOLESALER, Channels.RETAIL];

    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }
}
